import React, { memo } from 'react';
import RatingIcon from './RatingIcon';
import { useRatingBarAnswer } from './hooks';

function Answer() {
  const configs = useRatingBarAnswer();

  return (
    <div aria-label="rating bar answer">
      {configs.map(config => (
        <RatingIcon key={config.level} {...config} />
      ))}
    </div>
  );
}

export default memo(Answer);
